// Dismissible offline warning banner — single source of truth for the repeated pattern
function OfflineBanner({visible, onDismiss}) {
  if (!visible) return null;
  return (
    <div style={{background:"#1a0a00",borderRadius:8,padding:"10px 14px",marginBottom:12,border:"1px solid #7c2d12",display:"flex",alignItems:"center",justifyContent:"space-between",gap:8}} onClick={onDismiss}>
      <div style={{fontSize:12,color:"#fb923c"}}>You're offline — upload and save are unavailable. Tap to dismiss.</div>
    </div>
  );
}

export default OfflineBanner;
